module.exports = __webpack_public_path__ + "img/symbol_6.aa1724a0.png";